import "../scss/style.scss";
import "./home.js";
import objectFitImages from 'object-fit-images';
import 'jquery-match-height';
import 'magnific-popup';
import 'lity';
import slick from 'slick-carousel';

jQuery(function ($) {

  // js-slick01
  if($('.js-slick01').children().length > 3){
    $('.js-slick01').slick({
      autoplaySpeed: 6000,
      autoplay: false,
      arrows: true,
      centerMode: true,
      dots: false,
      infinite: true,
      fade: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      variableWidth: false,
    });
  } else {
    $('.js-slick01').addClass('is_noslide');
  }


  if($('.js-slick02').children().length > 3){
    $('.js-slick02').slick({
      autoplaySpeed: 6000,
      autoplay: false,
      arrows: true,
      centerMode: true,
      dots: false,
      infinite: true,
      fade: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      variableWidth: false,
    });
  } else {
    $('.js-slick02').addClass('is_noslide');
  }

  //  modal
	$(function () {
		$('.js-popup-area').magnificPopup({
			delegate: 'a',
      type: 'inline',
      fixedContentPos: 'true',
      fixedBgPos: 'true',
			gallery: {
				enabled: true
      }
		});
  });

  // smooth scroll
  var headerHeight = $('.header').outerHeight();
  var urlHash = location.hash;
  if (urlHash) {
    $('body,html').stop().scrollTop(0);
    setTimeout(function() {
      var target = $(urlHash);
      var position = target.offset().top - headerHeight;
      $('body,html').stop().animate({
        scrollTop: position
      }, 500);
    }, 100);
  }
  $('a[href^="#"]').click(function() {
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top - headerHeight;
    $('body,html').stop().animate({
      scrollTop: position
    }, 500);
    return false;
  });

  // SP menu
  $(function(){
    $('.js-nav-btn').on('click', function () {
      if ($(this).hasClass('is-close')) {
        $(".nav-sp-content, .js-nav-overlay").removeClass('is-open');
        $(this).removeClass('is-close');
      } else {
        $(".nav-sp-content, .js-nav-overlay").addClass('is-open');
        $(this).addClass('is-close');
      }
      if ($('.nav-search').hasClass('is-open')) {
        $(".nav-search").removeClass('is-open');
      }
    });
    $('.js-nav a[href^="#"], .js-nav-overlay').on('click',function(){
      $(".nav-sp-content, .js-nav-overlay").removeClass('is-open');
      $('.js-nav-btn').removeClass('is-close');
    });
  });

  // 検索メニュー
  $(function(){
    $('.nav-box-list__item.is_search a').on('click',function(){
      $(".nav-search, .js-nav-overlay").toggleClass('is-open');
      $('.js-nav-btn').toggleClass('is-close');
    });
  });

  // ドロップダウン
  $(function () {
    var dropdown = $('.nav-list__item.dropdown');
    var dropdownItem = $('.nav-list__item.dropdown .dropdown_item');
    var toggleClickA = $('.nav-list__item.dropdown .top');
    if (matchMedia('(max-width: 767px)').matches) {
      dropdown.removeClass('close');
      dropdownItem.css('display', 'block');
      toggleClickA.on('click', function () {
        dropdown.toggleClass('close');
        dropdownItem.stop().slideToggle();
      });
    } else {
      dropdownItem.removeClass('open');
      dropdown.hover(function (e) {
        $(this).find(dropdownItem).addClass('open');
      }, function () {
        $(this).find(dropdownItem).removeClass('open');
      });
    }
  });

  // pagetop
  $(function(){
    $(window).scroll(function () {
      if($(this).scrollTop() >= 300) {
        $('.js-pagetop').fadeIn();
      } else {
        $('.js-pagetop').fadeOut();
      }
    });
  });

  $(function () {
    objectFitImages('.js-objectfit-img');
  });

  // 言語プルダウン
  $(function () {
    if (matchMedia('(max-width: 767px)').matches) {
      $('.nav-box-list__item.is_language').on('click', function (event) {
        $('.nav-box-list__item__child').slideToggle();
      });
    } else {
      $('.nav-box-list__item.is_language').hover(function (event) {
        $('.nav-box-list__item__child').stop().slideDown();
      }, function (event) {
        $('.nav-box-list__item__child').stop().slideUp();
      });
    }
  });

  // プルダウン
  $('.js-pullDown').on('click', function (event) {
    if (matchMedia('(max-width: 767px)').matches) {
      event.preventDefault();
      $(this).find('.p-resorts__ttl').toggleClass('is_open');
      $(this).next().slideToggle();
    }
  });

  // プルダウン
  $('.fix_banner__close').on('click', function (event) {
    $('.fix_banner').hide();
  });

  $(function(){
    $('.p-company__tagList >li').each(function(index,element){
      var w = $(element).width()
      $('.p-company__tagList').append('<li style="height:0; width:'+ w +'px; margin:0;"></li>')
    })
  })

  // scroll animation
	$(document).on('load scroll', function () {
		$('.js-fadeUp').each(function () {
			var targetElement = $(this).offset().top;
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
				if (scroll > targetElement - windowHeight + 100){
					$(this).addClass('scrollin');
			}
			// else {
			// 	$(this).removeClass('scrollin');
			// }
		});
	});


});